import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Compass, ArrowLeft } from 'lucide-react';

export default function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div
      data-testid="not-found-page"
      className="min-h-screen bg-[#050914] text-white flex items-center justify-center px-6 selection:bg-cyan-400/30"
    >
      <div className="max-w-md w-full text-center">
        <div className="w-14 h-14 rounded-2xl bg-cyan-400/10 border border-cyan-400/30 flex items-center justify-center mx-auto mb-6">
          <Compass className="w-7 h-7 text-cyan-400" strokeWidth={1.5} />
        </div>
        <p className="text-6xl font-light tracking-tight text-white/90 mb-2">404</p>
        <h1 className="text-xl font-medium text-white mb-2">Halaman tidak ditemukan</h1>
        <p className="text-sm text-white/60 mb-7">
          Tautan yang Anda tuju tidak tersedia atau sudah dipindahkan.
        </p>
        <button
          data-testid="not-found-home"
          onClick={() => navigate('/')}
          className="inline-flex items-center gap-2 bg-cyan-400 text-[#050914] font-medium px-6 py-2.5 rounded-lg transition-colors hover:bg-cyan-300"
        >
          <ArrowLeft className="w-4 h-4" strokeWidth={2} /> Kembali ke Beranda
        </button>
      </div>
    </div>
  );
}
